import {
    isFeatureEnabled,
    toFeatureState,
} from '@etrigan/feature-toggles-client'
import { metrics, TheWestSection } from '@news-mono/component-library'
import { StaticRoutes, Store } from '@news-mono/web-common'
import { CheckedComponentInformation } from 'json-react-layouts'
import { layout } from '../../App.routing'
import { billboardLeaderboardMrec } from '../ad-units'
import { olympicsCurationSegment } from '../topic/custom/olympics-segment'
import { aflSegment } from './afl-segment'
import { brandContentSegment } from './brand-content-segment'
import { businessSegment } from './business-segment'
import { coronavirusSegment } from './coronavirus-segment'
import { courtsCrimeSegment } from './courts_crime'
import { entertaimentAndLifestyleSegment } from './entertainment-lifestyle-segment'
import { foodAndDrinkSegment } from './food-and-drink-segment'
import { homeSegment } from './home-segment'
import { inCaseYouMissedItSegment } from './in-case-you-missed-it-segment'
import { indigenousAffairsSegment } from './indigenous-affairs'
import { liveSportSegment } from './live-sport-segment'
import { miscCollectionsSegment } from './misc-collections-segment'
import { moreSportSegment } from './more-sport-segment'
import { opinionSegment } from './opinion-segment'
import { politicsSegment } from './politics-segment'
import { propertySegment } from './property-segment'
import { regionalSegment } from './regional-segment'
import { subscriberExclusive } from './subscriber-exclusive'
import { telethonCountdown } from './telethon-countdown'
import { travelSegment } from './travel-segment'
import { waflPsaSegment } from './wafl-psa-segment'
import { worldSegment } from './world-segment'
import { yourMoneySegment } from './your-money-segment'

const rampAdUnit = layout.component({
    type: 'ad-unit',
    props: {
        noticePosition: 'below-center',
        hiddenUntilLoaded: true,
        padding: [0, 0, metrics.thewest.margins.lg, 0],
        slot: {
            id: 'ramp',
            size: 'ramp',
            exclusionLabels: ['NoAds'],
        },
    },
})

export const homepage: StaticRoutes<TheWestSection> = {
    '': ({ getAdTargeting, store }) => ({
        kind: 'page',
        heading: 'The West Australian | Perth, WA, National & World News',
        pageType: 'homepage',
        hideHeading: true,
        refreshOnInactive: true,
        noMetaTitleTemplate: true,
        pageMeta: {
            title: 'The West Australian | Perth, WA, National & World News',
            description:
                'The West Australian is a leading news source in Perth and WA. Breaking local and world news from sport and business to lifestyle and current affairs.',
        },
        adTargeting: getAdTargeting('home', 'default', 'home'),
        section: 'default',

        compositions: [
            mainContentSection(
                [
                    olympicsCurationSegment({
                        isWidgetFallbackEnabled: isFeatureEnabled(
                            toFeatureState(store.getState().toggles),
                            'tokyo-medal-widget-fallback',
                        ),
                    }),
                    liveSportSegment,
                    coronavirusSegment,
                    rampAdUnit,
                    subscriberExclusive(),
                    ...businessSegment,
                    telethonCountdown,
                    inCaseYouMissedItSegment(
                        store.getState().render.renditionType,
                    ),
                    ...billboardLeaderboardMrec('one'),
                    courtsCrimeSegment,
                    politicsSegment,
                    entertaimentAndLifestyleSegment,
                    ...billboardLeaderboardMrec('two'),
                    ...aflSegment,
                    waflPsaSegment,
                    moreSportSegment,
                    indigenousAffairsSegment,
                    ...billboardLeaderboardMrec('three'),
                    opinionSegment,
                    worldSegment,
                    yourMoneySegment,
                    propertySegment,
                    foodAndDrinkSegment,
                    ...brandContentSegment,
                    regionalSegment,
                    ...travelSegment,
                    miscCollectionsSegment,
                ],
                store,
            ),
            layout.composition({
                type: 'thor',
                props: {
                    hasBackgroundFill: false,
                    containerWidth:
                        metrics.thewest.siteMetrics.mainContentWidth,
                    horizontalGutters: 'outerMargin',
                    verticalGutters: 'xl',
                },
                contentAreas: {
                    main: [
                        layout.component({
                            type: 'taboola',
                            props: {
                                taboolaContainerId:
                                    'taboola-below-home-thumbnails',
                                locationType: 'home',
                            },
                        }),
                    ],
                },
            }),
        ],
    }),
}

function mainContentSection(
    components: Array<CheckedComponentInformation>,
    store: Store,
) {
    return layout.composition({
        type: 'thor',
        props: {
            hasBackgroundFill: false,
            containerWidth: metrics.thewest.siteMetrics.mainContentWidth,
            horizontalGutters: false,
            verticalGutters: false,
        },
        contentAreas: {
            main: [
                homeSegment(store),
                layout.nestedComposition({
                    type: 'thor',
                    props: {
                        hasBackgroundFill: true,
                        containerWidth: '100%',
                        verticalGutters: false,
                        horizontalGutters: true,
                    },
                    contentAreas: {
                        main: components,
                    },
                }),
            ],
        },
    })
}
